<template>
  <icon-base
    :title="title"
    :name="name"
    :viewbox="viewBox">
    



<g>
	<path d="M3.75,24c-1.241,0-2.25-1.009-2.25-2.25v-9C1.5,12.336,1.836,12,2.25,12S3,12.336,3,12.75v3.75h11.25v-3.75
		c0-0.414,0.336-0.75,0.75-0.75s0.75,0.336,0.75,0.75v9.75h4.5c0.414,0,0.75-0.336,0.75-0.75v-9c0-0.414,0.336-0.75,0.75-0.75
		s0.75,0.336,0.75,0.75v9c0,1.241-1.009,2.25-2.25,2.25H3.75z M3,21.75c0,0.414,0.336,0.75,0.75,0.75h10.5V18H3V21.75z"/>
	<path d="M21,10.5c-0.863,0-1.685-0.38-2.25-1.018C18.185,10.12,17.363,10.5,16.5,10.5s-1.685-0.38-2.25-1.018
		C13.685,10.12,12.863,10.5,12,10.5s-1.685-0.38-2.25-1.018C9.185,10.12,8.363,10.5,7.5,10.5s-1.685-0.38-2.25-1.018
		C4.685,10.12,3.863,10.5,3,10.5c-1.654,0-3-1.346-3-3c0-0.054,0.006-0.108,0.018-0.162l1.369-6.164C1.542,0.483,2.144,0,2.852,0
		h18.295c0.698,0,1.314,0.494,1.465,1.175l1.37,6.162C23.994,7.389,24,7.444,24,7.5C24,9.154,22.654,10.5,21,10.5z M18.75,6.75
		c0.414,0,0.75,0.336,0.75,0.75C19.5,8.327,20.173,9,21,9c0.796,0,1.459-0.636,1.498-1.426L21.148,1.5l-18.296,0l-1.35,6.074
		C1.541,8.364,2.204,9,3,9c0.827,0,1.5-0.673,1.5-1.5c0-0.414,0.336-0.75,0.75-0.75S6,7.086,6,7.5C6,8.327,6.673,9,7.5,9
		S9,8.327,9,7.5c0-0.414,0.336-0.75,0.75-0.75S10.5,7.086,10.5,7.5C10.5,8.327,11.173,9,12,9s1.5-0.673,1.5-1.5
		c0-0.414,0.336-0.75,0.75-0.75S15,7.086,15,7.5C15,8.327,15.673,9,16.5,9S18,8.327,18,7.5C18,7.086,18.336,6.75,18.75,6.75z"/>
</g>


  </icon-base>
</template>

<script>
import IconBase from '../IconBase';

export default {
  components: {
    IconBase,
  },
  props: {
    title: {
      type: String,
      required: false,
      default: 'shop',
    },
    name: {
      type: String,
      required: false,
      default: 'Shop',
    },
    viewBox: {
      type: String,
      required: false,
      default: '0 0 24 24',
    },
  },
};
</script>

<style scoped>
  
</style>